<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex>
        <v-tabs color="transparent" v-model="active" slider-color="secondary">
          <v-tab ripple>Expenses</v-tab>
          <v-tab ripple>Categories</v-tab>

          <v-tab-item>
            <list/>
          </v-tab-item>

          <v-tab-item>
            <categories/>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Categories from "./categories";
import List from "./list";
export default {
  components: {
    List,
    Categories
  },
  data() {
    return {
      active: null
    };
  }
};
</script>